import React, { useState, useEffect } from "react";
import "./Tabs.css";
import "../../assets/css/component.css";
import "../../assets/css/modal.css";
import { ButtonGroup, Dropdown } from "react-bootstrap";

import DeliveryModal from "../DeliveryModal/DeliveryModal";
import DeliveryTime from "../DeliveryModal/DeliveryTime";
import OrderPlaced from "../OrderPlaced/OrderPlaced";
import { scroller } from "react-scroll";
import SearchBar from "../HomeSearch/SearchBar";

// import APIHandler from '../../utils/APIHandler';
// import { GET_ALL_CATEGORIES } from '../../utils/urls';

const Tabs = (props) => {
  const [showDelivery, setShowDelivery] = useState(false);
  const [showDeliveryTime, setShowDeliveryTime] = useState(false);
  const [showOrderPlaced, setShowOrderPlaced] = useState(false);

  const [categoryMenu, setCategoryMenu] = useState(null);

  const [activeItem, setActiveItem] = useState('all');

  const [scrollTo, setScrollTo] = useState(1);

  const [showUlCategories, setUlCategories] = useState([]);
  const [showDropdownCategories, setDropdownCategories] = useState([]);
  const [isScrolling, setIsScrolling] = useState(false);


  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
  const updateDimensions = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  }

  const filteredCategories =
    props.category &&
    Object.keys(props.category)
      .filter((key) => props.category[key]?.not_for_pickup_delivery !== 1)
      .reduce((acc, key) => {
        acc[key] = props.category[key];
        return acc;
      }, {});

  useEffect(() => {
    const handleScroll = () => {
      if (!filteredCategories) return;
      if (isScrolling) return;
      const keys = Object.keys(filteredCategories);
      const offsetTop = 270;

      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        const elements = document.getElementsByClassName(
          `con-${filteredCategories[key].id}`
        );
        // A category can have several blocks (price-filtered view), so check all of them
        const isActive = Array.from(elements).some((element) => {
          const rect = element.getBoundingClientRect();
          return rect.top <= offsetTop && rect.bottom > offsetTop;
        });
        if (isActive) {
          if (activeItem !== i) {
            setActiveItem(i);
          }
          break;
        }
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [props.category, activeItem, isScrolling]);

  const scrollToElement = (id, index) => {
    setIsScrolling(true);
    scroller.scrollTo("con-" + id, {
      duration: 500,
      smooth: true,
      offset: -270,
    });
    setActiveItem(index);

    setTimeout(() => {
      setIsScrolling(false);
    }, 520);
  };
  const handleCategoryClick = (id, index) => {
    if (activeItem === index) return;
    scrollToElement(id, index);
    if (props.onCategorySelect) {
      props.onCategorySelect(id);
    }
  };
  const renderCat = () => {
    // let html = [];

    // let html2 = [];

    // if (props.category && Object.keys(props.category.data).length > 0) {
    //   Object.keys(props.category.data).map((key, index) => {

    //     if (index < 4) {

    //       html.push(
    //         <li key={index} className="nav-item">
    //         {console.log(index)}
    //           <button 
    //             className={ 
    //              activeItem === index ? "nav-link active" : "nav-link"
    //             } 
    //             id="pills-2-tab"
    //             data-toggle="pill"
    //             role="tab"
    //             aria-selected="false"
    //             onClick={(e) => {
    //               scrollToElement(props.category.data[key].id, index)
    //               console.log(props.category.data[key].id)
    //             }}
    //           >
    //             {" "}
    //             {props.category.data[key].name}{" "}

    //           </button>
    //         </li>
    //       );

    //     } else {
    //       html2.push(
    //         <Dropdown.Item
    //           eventKey={key}
    //           onClick={(e) =>
    //             scrollToElement(props.category.data[key].id, index)
    //           }
    //           className="border-bottom"
    //         >
    //           {props.category.data[key].name}
    //         </Dropdown.Item>
    //       );
    //     }
    //   });
    // }
    // //setCategoryMenu(html2);
    // return html;

    let html = [];
    let html2 = [];
    html.push(
      <li key="all" className="nav-item">
        <button
          className={activeItem === "all" ? "nav-link active" : "nav-link"}
          onClick={() => {
            setActiveItem("all");
            if (props.onCategorySelect) {
              props.onCategorySelect(null);
            }
          }}
        >
          All
        </button>
      </li>
    );
    if (filteredCategories && Object.keys(filteredCategories).length > 0) {
      Object.keys(filteredCategories).map((key, index) => {
        if (index < 3) {
          html.push(
            <li key={index} className="nav-item">
              <button
                className={
                  activeItem === index ? "nav-link active" : "nav-link"
                }
                id="pills-2-tab"
                data-toggle="pill"
                role="tab"
                aria-selected="false"
                onClick={() => handleCategoryClick(props.category[key].id, index)}
              >
                {" "}
                {props.category[key].name}{" "}

              </button>
            </li>
          );

        }
        // else {
        //   html2.push(
        //     <Dropdown.Item
        //       eventKey={key}
        //       onClick={(e) =>
        //         scrollToElement(props.category[key].id, index)
        //       }
        //       className="border-bottom"
        //     >
        //       {props.category[key].name}
        //     </Dropdown.Item>
        //   );
        // }
      });
    }
    //setCategoryMenu(html2);
    return html;



  };
  const renderCat2 = () => {
    // let html2 = [];
    // console.log(props.category);
    // if (props.category && Object.keys(props.category.data).length > 0) {
    //   Object.keys(props.category.data).map((key, index) => {

    //     if (index >= 4) {
    //       console.log(props.category.data[key].name);

    //       html2.push(
    //         <Dropdown.Item
    //           key={index}
    //           eventKey={key}
    //           onClick={(e) =>
    //             scrollToElement(props.category.data[key].id, index)
    //           }
    //           className="border-bottom"

    //         >
    //           {props.category.data[key].name}
    //         </Dropdown.Item>
    //       );
    //     }
    //   });
    // }
    // //setCategoryMenu(html2);
    // return html2;

    let html2 = [];

    if (filteredCategories && Object.keys(filteredCategories).length > 0) {
      Object.keys(filteredCategories).map((key, index) => {

        if (index >= 3) {
          html2.push(
            <Dropdown.Item
              key={index}
              eventKey={key}
              onClick={() => handleCategoryClick(props.category[key].id, index)
              }
              className={`border-bottom ${activeItem === index ? "active" : ""}`}

            >
              {props.category[key].name}
            </Dropdown.Item>
          );
        }
      });
    }
    //setCategoryMenu(html2);
    return html2;

  };
  const renderCatMobile = () => {
    let html2 = [];

    if (props.category && Object.keys(props.category).length > 0) {
      Object.keys(props.category).map((key, index) => {

        html2.push(
          <Dropdown.Item
            key={index}
            eventKey={key}
            onClick={() => handleCategoryClick(props.category[key].id, index)
            }
            className="border-bottom"
          >
            {props.category[key].name}
          </Dropdown.Item>
        );
      });
    }
    //setCategoryMenu(html2);
    return html2;
  };
  const isMoreActive = () => {
    if (!props.category) return false;
    return activeItem >= 3; // if any category from dropdown is active
  };
  return (
    <>
      {/* <span> */}
      <div className="tab-ember primary">

        <DeliveryModal
          show={showDelivery}
          closeModal={() => setShowDelivery(false)}
        />
        <DeliveryTime
          show={showDeliveryTime}
          closeModal={() => setShowDeliveryTime(false)}
        />
        <OrderPlaced
          show={showOrderPlaced}
          closeModal={() => setShowOrderPlaced(false)}
        />
        <ul className="nav nav-pills" id="pills-tab" role="tablist" style={{ marginBottom: "1%" }}>
          {renderCat()}

          {props.category !== null && Object.keys(props.category).length > 3 ? <li className="nav-item dropdown">
            <Dropdown as={ButtonGroup}>
              <Dropdown.Toggle
                variant="light"
                id="dropdown-custom-1"
                className={`more-dropdown border-0 ${isMoreActive() ? "active" : ""
                  }`}
              >
                More
              </Dropdown.Toggle>
              <Dropdown.Menu renderOnMount className="category-menu">
                {renderCat2()}
              </Dropdown.Menu>
            </Dropdown>
          </li> : null}
        </ul>
        <SearchBar searchValue={props.searchValue} setSearchValue={props.setSearchValue} priceSort={props.priceSort} setPriceSort={props.setPriceSort} />
      </div>
      <div className="tab-ember primary mobile">
        <div className="mobile-scroll-wrapper">
          <div
            className={`mobile-category-item see-all-btn ${activeItem === "all" ? "active" : ""}`}
            onClick={() => {
              setActiveItem("all");
              if (props.onCategorySelect) {
                props.onCategorySelect(null);
              }
            }}
          >
            All
          </div>

          <div className="mobile-scroll-container">
            {filteredCategories &&
              Object.keys(filteredCategories).map((key, index) => (
                <div
                  key={index}
                  className={`mobile-category-item ${activeItem === index ? "active" : ""}`}
                  onClick={() => handleCategoryClick(props.category[key].id, index)}
                >
                  {props.category[key].name}
                </div>
              ))}
          </div>
        </div>
        <SearchBar searchValue={props.searchValue} setSearchValue={props.setSearchValue} priceSort={props.priceSort} setPriceSort={props.setPriceSort} />
      </div>

      {/* </span> */}
    </>
  );
};

export default Tabs;
